const TargetBookingScreens = {
  TargetBooking: {
    PATH: '/target-booking',
    TITLE: 'Target Booking',
    TITLE_ALT: 'Target Booking',
    PERMISSION: 'TARGET_BOOKING.read'
  },
  UploadTargetBooking: {
    PATH: '/target-booking/upload-target-booking',
    TITLE: 'Upload Target Booking',
    TITLE_ALT: 'Upload Target Booking',
    PERMISSION: 'TARGET_BOOKING.read',
  },
  AddUploadTargetBooking: {
    PATH: '/target-booking/upload-target-booking/add',
    TITLE: 'Upload Target Booking',
    TITLE_ALT: 'Upload Target Booking',
    PERMISSION: 'TARGET_BOOKING.insert_update',
  },
  ViewUploadTargetBooking: {
    PATH: '/target-booking/upload-target-booking/detail/:id',
    TITLE: 'Detail Data Target Booking',
    TITLE_ALT: 'Detail Data Target Booking',
    PERMISSION: 'TARGET_BOOKING.read',
  },
  MaintenanceTargetBooking: {
    PATH: '/target-booking/maintenance-target-booking',
    TITLE: 'Maintenance Target Booking',
    TITLE_ALT: 'Maintenance Target Booking',
    PERMISSION: 'TARGET_BOOKING.read'
  },
  EditMaintenanceTargetBooking: {
    PATH: '/target-booking/maintenance-target-booking/edit/:id',
    TITLE: 'Edit Target Booking',
    TITLE_ALT: 'Edit Target Booking',
    PERMISSION: 'TARGET_BOOKING.insert_update',
  },
  ViewMaintenanceTargetBooking: {
    PATH: '/target-booking/maintenance-target-booking/view/:id',
    TITLE: 'Detail Target Booking',
    TITLE_ALT: 'Detail Target Booking',
    PERMISSION: 'TARGET_BOOKING.read',
  },
}

export default TargetBookingScreens
